import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { IntegrationState } from './integration.model';
import { IntegrationStore } from './integration.store';

@Injectable({ providedIn: 'root' })
export class IntegrationStoreQuery extends QueryEntity<IntegrationState> {
  constructor(protected readonly store: IntegrationStore) {
    super(store);
  }
}
